module.exports = __webpack_public_path__ + "static/media/file-powerpoint.e329f3e8.svg";